import Vue from 'vue';
import store from '@/store/index';
import errorIcon from '@/assets/images/icons/error.svg';
import i18n from '@/lang';

// 共用 error handler 方法
const commonErrorHandler = (errMsg) => {
  store.dispatch('alert/setAlertInfo', {
    icon: errorIcon,
    title: i18n.t('global.msg_errorTitle'),
    desc: errMsg || '未預期的錯誤，請聯絡工程人員',
    buttons: [
      {
        key: 'confirm',
        text: i18n.t('global.btn_comfirm'),
        btnStyle: 'btn-primary btn-round',
        onClick: () => store.dispatch('alert/closeAlert'),
      },
    ],
  });
};

// 將物件 {a:valA, b:valB} 組成querystring字串 a=valA&b=valB
const commonObjToQueryString = (params) => {
  if (!params) return null;
  const queryString = Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join('&');

  return queryString;
};

/**
* 用key取data (可支援nested obj)
* @param {Object} data 資料物件
* @param {String} fieldKey 資料key, 一般格式為'keyA', nested格式為'keyA.keyB.keyC'
* @return {String} data value
*/
const commonGetDataByKey = (data, fieldKey) => {
  if (!fieldKey) {
    return null;
  }
  // nested object的格式為: a.b.c，先切成array, 再拿到nested obj的value
  const keys = fieldKey.split('.');
  if (keys.length === 1) return data[keys[0]];
  return keys.reduce((obj, key) => {
    if (obj && obj[key] !== 'undefined') {
      return obj[key];
    }
    return undefined;
  }, data);
};

Vue.prototype.$commonObjToQueryString = commonObjToQueryString;
Vue.prototype.$commonErrorHandler = commonErrorHandler;
Vue.prototype.$commonGetDataByKey = commonGetDataByKey;

export default { commonErrorHandler };
